import React from "react";
import { formatPrice, isZero } from "../../../utils/helper";

const clampPrice = (value) => (value < 0 ? 0.0 : value);

const Prices = ({ item, labels,isFromListing }) =>
    item?.bundlePrice != null ? (
        <div className="shopping-plan-prices with-rateplan">
            <div className="shopping-plan-bundle-price-container">
                <div className="shopping-plan-bundle-price-label">
                    {labels["withRateplan"]}
                </div>
                <div className="shopping-plan-bundle-price-value">
                    {!isZero(item?.bundlePrice) &&
                    formatPrice(clampPrice(item?.bundlePrice)) !== "0,00€"
                        ? formatPrice(clampPrice(item?.bundlePrice))
                        : labels["freePrice"]}
                </div>
            </div>

            <div className="shopping-plan-price-container">
                {isZero(item?.finalPrice) ? (
                    <div className="shopping-plan-price-free-label">
                        {labels["freePrice"]}
                    </div>
                ) : (
                    <>
                        <div className="shopping-plan-price-label">
                            {!isZero(item?.initialPrice) &&
                            item?.initialPrice !== item?.finalPrice
                                ? labels["initialPrice"]
                                : labels["finalPrice"]}
                        </div>

                        {!isZero(item?.initialPrice) &&
                            item?.initialPrice !== item?.finalPrice && !isFromListing && (
                                <div
                                    className="shopping-plan-initial-price-value"
                                    aria-label={"Αρχική τιμή: " + clampPrice(item?.initialPrice) + "€"}
                                >
                                    {formatPrice(clampPrice(item?.initialPrice))}
                                </div>
                            )}

                        <div
                            className="shopping-plan-final-price-value"
                            aria-label={"Τελική τιμή: " + clampPrice(item?.finalPrice) + "€"}
                        >
                            {formatPrice(clampPrice(item?.finalPrice))}
                        </div>
                    </>
                )}
            </div>
        </div>
    ) : (
        <div className="shopping-plan-prices without-rateplan">
            <div className="shopping-plan-price-container">
                {isZero(item?.finalPrice) ? (
                    <div className="shopping-plan-price-free-label">
                        {labels["freePrice"]}
                    </div>
                ) : (
                    <>
                        <div className="shopping-plan-price-label">
                            {isZero(item?.initialPrice) ||
                            !item?.initialPrice ||
                            item?.initialPrice === item?.finalPrice
                                ? labels["finalPrice"]
                                : labels["initialPrice"]}
                        </div>

                        <div className="shopping-plan-price-values">
                            {!isZero(item?.initialPrice) &&
                                item?.initialPrice &&
                                item?.initialPrice !== item?.finalPrice && (
                                    <div className="shopping-plan-initial-price-value">
                                        {formatPrice(clampPrice(item?.initialPrice))}
                                    </div>
                                )}

                            <div
                                className="shopping-plan-final-price-value"
                                aria-label={"Τελική τιμή: " + clampPrice(item?.finalPrice) + "€"}
                            >
                                {formatPrice(clampPrice(item?.finalPrice))}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );

export default Prices;
